import React from 'react';
import styled from 'styled-components/macro';
import { RATIO_HEIGHT_PIXEL_TO_REAL_SIZE } from '../../constants';
import StyledDimensionValue from '../../styles/StyledDimensionValue';

interface Props {
  wheelsHeight: number;
}

const WheelsSchemaDimensions = ({ wheelsHeight }: Props) => {
  return (
    <StyledWheelsSchema wheelsHeight={wheelsHeight}>
      <div className="absolute h-full w-full flex items-center justify-end">
        <StyledDimensionValue noBackground>
          {wheelsHeight / 10}
        </StyledDimensionValue>
      </div>
      <div className="absolute h-full w-full flex items-center justify-start pl-6">
        <StyledWheelSchema wheelsHeight={wheelsHeight} />
      </div>
      <div className="absolute h-full w-full flex items-center justify-end pr-6">
        <StyledWheelSchema wheelsHeight={wheelsHeight} />
      </div>
    </StyledWheelsSchema>
  );
};

const StyledWheelsSchema = styled.div<{
  wheelsHeight: number;
}>`
  border-top: 2px solid black;
  height: ${p => p.wheelsHeight * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE}px;
  width: 100%;
  display: grid;
  justify-content: right;
  align-items: center;
  position: relative;
`;

const StyledWheelSchema = styled.div<{
  wheelsHeight: number;
}>`
  border: 1px solid black;
  height: ${p => p.wheelsHeight * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE - 2}px;
  width: ${p => p.wheelsHeight * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE - 2}px;
  border-radius: 50%;
`;

export default WheelsSchemaDimensions;
